import { CameraForm } from "@/types/camera.type";
import axios from "./api";

/**
 * do login
 * @param username
 * @param password
 * @returns
 */
export const getCameras = (): Promise<CameraForm[]> => {
  return axios
    .get<CameraForm[]>(`/camera`)
    .then((res) => {
      return res.data;
    })
    .catch((res) => {
      throw new Error(res.status);
    });
};
